import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import {
    getPendingProviders,
} from "../../services/adminProviderService";

export default function PendingProviders() {

    const [providers, setProviders] = useState([]);

    const [loading, setLoading] = useState(true);

    useEffect(() => {

        loadProviders();

    }, []);

    const loadProviders = async () => {

        try {

            const res = await getPendingProviders();

            setProviders(res.providers);

        } catch (err) {

            console.log(err);

        }

        setLoading(false);

    };

    if (loading) {

        return <h2>Loading...</h2>;

    }

    return (

        <div>

            <h2>Pending Providers</h2>

            <table>

                <thead>

                    <tr>

                        <th>Owner</th>

                        <th>Business</th>

                        <th>Phone</th>

                        <th>Type</th>

                        <th>Action</th>

                    </tr>

                </thead>

                <tbody>

                    {providers.map((provider) => (

                        <tr key={provider._id}>

                            <td>{provider.ownerName}</td>

                            <td>
                                {provider.business?.businessName}
                            </td>

                            <td>{provider.phone}</td>

                            <td>{provider.providerType}</td>

                            <td>

                                <Link
                                    to={`/admin/providers/${provider._id}`}
                                >
                                    View
                                </Link>

                            </td>

                        </tr>

                    ))}

                </tbody>

            </table>

        </div>

    );

}